import { render, staticRenderFns } from "./ReportChatChannelModal.vue?vue&type=template&id=86ddd5a0&scoped=true&"
import script from "./ReportChatChannelModal.vue?vue&type=script&lang=ts&"
export * from "./ReportChatChannelModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReportChatChannelModal.vue?vue&type=style&index=0&id=86ddd5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ddd5a0",
  null
  
)

export default component.exports